export default __webpack_public_path__ + "assets/surface.94e4484f.svg";